import React, { useState } from 'react';
import ApplicationForm from '../components/ApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const ContactUs = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);

  return (
    <>
      {/* Page Title Banner */}
      <div className="page-title aos-init aos-animate" data-aos="fade">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1 className="">Contact Us</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <section id="contact" className="contact section">
        <div className="container aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-5">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8598.081532250924!2d74.63412674072812!3d25.03244610574349!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3968a2d6d6e9b871%3A0x5fdecf981b58c0dd!2sMewar%20University!5e0!3m2!1sen!2sin!4v1759143453850!5m2!1sen!2sin" 
                  width="100%" 
                  height="400" 
                  style={{border: 0}} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mewar University Location"
                ></iframe>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-item d-flex align-items-center aos-init aos-animate my-2" data-aos="fade-up" data-aos-delay="200">
                <i className="icon bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h3>Address</h3>
                  <p>NH - 48 Gangrar<br />Chittorgarh, Rajasthan - 312901</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-center aos-init aos-animate my-2" data-aos="fade-up" data-aos-delay="300">
                <i className="icon bi bi-telephone flex-shrink-0"></i>
                <div>
                  <h3>Call Us</h3>
                  <p>+91 9137954770</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-center aos-init aos-animate my-2" data-aos="fade-up" data-aos-delay="400">
                <i className="icon bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h3>Email Us</h3>
                  <p>info@distanceengineering.org</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-center aos-init aos-animate my-2" data-aos="fade-up" data-aos-delay="500">
                <i className="icon bi bi-clock flex-shrink-0"></i>
                <div>
                  <h3>Opening Hours<br /></h3>
                  <p><strong>Mon-Sat:</strong> 11AM - 23PM; <strong>Sunday:</strong> Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="section bg-light">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <div className="row">
            <div className="col-md-12 col-lg-9 mx-auto">
              <h2 className="fs-1 fw-bold my-4 text-center">Ready to Advance Your Engineering Career?</h2>
              <h4 className="fw-light px-lg-4 px-xl-5 mb-4 mb-lg-5 text-center">Thousands of professionals in the workforce have improved their credentials by enrolling in our adaptable B.Tech program.</h4>
              <div className="d-flex gap-1 justify-content-center ftr-banner-btn">
                <button 
                  className="btnsecondary btn-get-started btn btn-info btn-lg" 
                  type="button" 
                  onClick={() => setShowApplicationModal(true)}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      {/* Application Modal */}
      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default ContactUs;
